import httpService from "./httpService";
import utils from "./utils";

export default {
  getListCategoryGroup(example) {
    return httpService.get("/categoryGroup", {params: example});
  },

  countCategoryGroup(config) {
    return httpService.get("/categoryGroup/count", config);
  },

  findAll(groupId, form, pageable) {
    let params = utils.merge({groupId: groupId}, form);
    params = utils.merge(params, pageable);
    return httpService.get("/category/findAll", {params: params});
  },

  findAllV2(form, pageable) {
    let params = utils.merge(form, pageable);
    return httpService.get("/category/findAll", {params: params});
  },

  findAllByCategoryGroupCode(categoryGroupCode) {
    let params = {categoryGroupCode: categoryGroupCode};
    return httpService.get("/category/findAllByCategoryGroupCode", {params: params});
  },

  countCategory(config) {
    return httpService.get("/category/count", config);
  },

  add(form) {
    return httpService.post("/category", form);
  },

  edit(form) {
    return httpService.post("/category/edit", form);
  },

  update(id, form) {
    return httpService.put(`/category/${id}`, form);
  },

  findById(id) {
    return httpService.get("category/" + id);
  },

  delete(id) {
    return httpService.delete("category/" + id);
  },

  changeStatus(id) {
    return httpService.put(`/category/${id}/changeStatus`);
  }
};



// WEBPACK FOOTER //
// ./src/services/categoryService.js